import React, { useEffect, useRef, useState } from 'react';
import FullCalendar, { formatDate } from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core';
import ControlledTreeView from '../../../Components/KenCheckBoxTree';
import resourcesData from '../TimeTable/data/resources.json';
import KenDialog from '../../../global_components/KenDialogBox';
import { makeStyles, withStyles } from '@material-ui/styles';
import './fullCalendar.css';
import Tooltip from '@material-ui/core/Tooltip';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenSelect from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import {
  addEventForBook,
  updateReferenceActivities,
  createBookedSlot,
  getAcademicFilter,
  getAcademicPlannerSession,
  getAllFacultyFacilitySubject,
  getBookedSlotDelete,
  getCourseVersion,
  getFaciltyAvailableData,
  getFacultyAndFacilty,
  getReferenceApi,
  getTermData,
} from '../../../Utils/apiServices';
import { intakeOptions, yearOptions } from '../AddActivity/data/data';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import Reference from './Reference';
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },

  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  actionBtn: {
    // margin: '0 10 px',
    float: 'right',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  popOverData: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#092682',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
}));

let DayArray = [];

const sessionColors = [
  {
    name: 'Lecture',
    color: '#1F618D',
  },
  {
    name: 'Exam',
    color: '#A04000',
  },
  {
    name: 'Lab',
    color: '##FF00FF', // Magenta
  },
  {
    name: 'Tutorial',
    color: '#800000', // Brown
  },
  {
    name: 'Practical',
    color: '#728FCE', // Light Purple Blue
  },
  {
    name: 'Workshop',
    color: '#C35817', // Red Fox
  },
  {
    name: 'Travel',
    color: '#7BCCB5', // Blue Green
  },
  {
    name: 'Term Break',
    color: '#4B5320', // Army Green
  },
  {
    name: 'Holiday',
    color: '#893BFF', // Aztech Purple
  },
  {
    name: 'Other',
    color: '#8B8000', // Dark Yellow
  },
];

const allDayaData = [
  {
    academicPlannerId: 'a231y00s0d000LNCvAAO',
    allDay: true,
    backgroundColor: undefined,
    editable: true,
    end: '2022-07-21T23:00:00',
    facilityBookingNumber: undefined,
    facilityCampus: undefined,
    facilityCapacity: undefined,
    facilityName: undefined,
    facilityType: undefined,
    id: 'a231y000000LNCvAAO',
    start: '2022-07-20T02:00:00',
    title: 'allDay',
  },
];
export default function FullCalendars() {
  const classes = useStyles();
  const [resources, setResources] = useState([]);
  const [treeItems, setTreeItems] = useState([]);
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);
  const [sections, setSections] = useState([]);
  const [faciltyOptions, setfaciltyOptions] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [readOnly, setReadOnly] = useState(false);
  const [sessionValue, setSessionValue] = useState('');
  const [expanded, setExpanded] = useState(['2']);
  const [eventData, setEventData] = useState(allDayaData);
  const [selected, setSelected] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmDialogAdd, setConfirmDialogAdd] = useState(false);
  const [confirmDialogAddReference, setConfirmDialogAddReference] =
    useState(false);
  const [confirmDialogDelete, setConfirmDialogDelete] = useState(false);
  const [confirmDialogView, setConfirmDialogView] = useState(false);
  const [confirmDialogViewReference, setConfirmDialogReferenceView] =
    useState(false);
  const [recurrent, setRecurrent] = useState(false);
  const [facultyName, setFacultyName] = useState('');
  const [facultyNameTwo, setFacultyNameTwo] = useState('');
  const [facultyNameThree, setFacultyNameThree] = useState('');
  const [facilityName, setFacilityName] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [startTime, setStartTime] = React.useState('');
  const [endTime, setEndTime] = React.useState('');
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [subjectView, setSubjectView] = React.useState('');
  const [faciltyView, setFaciltyView] = React.useState('');
  const [sectionView, setSectionView] = React.useState('');
  const [facultyView, setFacultyView] = React.useState('');
  const [facultyViewTwo, setFacultyViewTwo] = React.useState('');
  const [facultyViewThree, setFacultyViewThree] = React.useState('');
  const [selectSubjectValue, setSelectSubjectValue] = React.useState('');
  const [selectSectionValue, setSelectSectionValue] = React.useState('');

  const [term, setTerm] = useState(sessionStorage.getItem('term'));
  const [termOptions, setTermOptions] = useState([]);
  const [year, setYear] = useState(sessionStorage.getItem('year'));
  const [intake, setIntake] = useState(sessionStorage.getItem('intake'));
  const [program, setProgram] = useState(sessionStorage.getItem('programName'));
  const [updateSession, setUpdateSession] = React.useState(false);
  const [state, setState] = React.useState({
    weekendsVisible: true,
    currentEvents: [],
  });

  const [courseOption, setCourseOption] = useState([]);
  const [programName, setProgramName] = useState('');
  const [filters, setFilters] = useState({});
  const [locationData, setLocationData] = useState();
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [checked, setChecked] = useState(true);
  const [checkedAssinged, setCheckedAssigned] = useState(false);
  const [alignment, setAlignment] = React.useState('session');
  const [alignments, setAlignments] = React.useState('faculty');

  const history = useHistory();
  const useItemStyles = makeStyles((theme) => ({
    root: {
      '& > .MuiTreeItem-content': {
        height: '35px',
      },
      '& > .MuiTreeItem-content > .MuiTreeItem-label': {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 0',
        background: 'transparent !important',
        pointerEvents: 'none',
        fontSize: '12px',
        lineHeight: '12px',
        padding: '0 15px 15px',
      },
      '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
        content: "''",
        display: 'inline-block',
        minWidth: 15,
        minHeight: 15,
        marginRight: 8,
        border: '1px solid #ccc',
        background: 'white',
      },
    },
    iconContainer: {
      marginRight: 3,
      marginLeft: 0,
      '& > svg': {
        '&:hover': {
          opacity: 0.6,
        },
      },
    },
    label: {
      padding: 0,
    },
    selected: {
      '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
        background: theme.palette.primary.main,
        // content: '\f095',
        border: '1px solid #ccc',
        // fontFamily: 'Font Awesome 5 Free',
      },
    },
    tooltipTable: {
      minWidth: ' 250px',
      maxWidth: '100%',
      padding: '30px',
      borderCollapse: ' collapse',
      background: '#ffffff',
      padding: '10px',
    },
    tooltipTable_Tr: {
      height: '25px',
      color: '#7A869A',
      fontSize: '12px',
      background: '#fff',
    },
    tooltipTable_td: {
      height: '25px',
      paddingLeft: '10px',
      color: '#7A869A',
      // background: '#f4f6fc',
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      // borderLeft: '1px solid #303030',
      fontSize: '12px',
    },
    tooltipTable_th: {
      height: '25px',
      paddingLeft: '10px',
      color: 'rgb(9, 38, 130)',
      background: '#ffffff',
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
  }));

  const BlueOnGreenTooltip = withStyles({
    tooltip: {
      color: 'lightblue',
      // backgroundColor: "green",
      // padding: 0,
      border: '1px solid #fff',
      borderRadius: '4px',
      background: '#ffffff',
      boxShadow: '-2px 1px 8px 1px #737f8d',
    },
  })(Tooltip);
  const classesItem = useItemStyles();

  const recurrenceDay = [
    {
      id: 'Sunday',
      label: 'SUN',
    },
    {
      id: 'Monday',
      label: 'MON',
    },
    {
      id: 'Tuesday',
      label: 'TUE',
    },
    {
      id: 'Wednusday',
      label: 'WED',
    },
    {
      id: 'Thrusday',
      label: 'THU',
    },
    {
      id: 'Friday',
      label: 'FRI',
    },
    {
      id: 'Saturday',
      label: 'SAT',
    },
  ];

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  // state =
  const handleFilter = (e, data) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const getColor = (title) => {
    const color = sessionColors.filter((e) => e.name == title);
    return color[0]?.color;
  };

  useEffect(async () => {
    if (program && year && intake && term) {
      if (alignment === 'session') {
        const termSession = await getAcademicPlannerSession(term);

        const propertyNames = termSession[term];
        let result = propertyNames?.filter(function (o1) {
          return selected.some(function (o2) {
            if (o1.SubjectPlanner) {
              return o1?.SubjectPlanner?.courseVersionId === o2; // return the ones with equal id
            }
          });
        });
        console.log('propertyNames', propertyNames);
        if (propertyNames) {
          const newEvents = [...result];
          const transformed = newEvents.map(
            ({
              activity,
              endDate,
              academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              facilityName,
              facilityType,
              id,
              startDate,
              startTime,
              endTime,
            }) => ({
              title: activity,
              end: `${endDate}T${endTime.slice(0, 8)}`,
              academicPlannerId: academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              facilityName,
              facilityType,
              id,
              start: `${startDate}T${startTime.slice(0, 8)}`,
            })
          );
          const newDataEvent = transformed.map((ele) => {
            return {
              ...ele,
              backgroundColor: getColor(ele.title),
              editable: true,
              allDay: false,
            };
          });

          setEventData(newDataEvent);
        }
      } else {
        const referenceData = await getReferenceApi(
          sessionStorage.getItem('term')
        );
        console.log('referenceData', referenceData);
        //2023-JAN-GMBA-Term1-Dubai-Planner
        const propertyNames =
          referenceData['2023-JAN-GMBA-Term1-Dubai-Planner'];
        if (propertyNames) {
          const newEvents = [...propertyNames];
          console.log('newDataEventnewDataEventnewDataEvent1111', newEvents);
          const transformed = newEvents.map(
            ({
              activityType,
              endDate,
              academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              facilityName,
              facilityType,
              subjectCourseName,
              faculty1Name,
              faculty2Name,
              faculty3Name,
              subjectId,
              faculty1Id,
              faculty2Id,
              faculty3Id,
              id,
              startDate,
            }) => ({
              title: activityType,
              end: `${endDate}T00:00:00`,
              academicPlannerId: academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              subjectCourseName,
              faculty1Id,
              faculty2Id,
              faculty3Id,
              subjectId,
              faculty1Name,
              faculty2Name,
              faculty3Name,
              facilityName,
              facilityType,
              activityId: id,
              start: `${startDate}T00:00:00`,
            })
          );
          const newDataEvent = transformed.map((ele) => {
            return {
              ...ele,
              backgroundColor: getColor(ele.title),
              editable: true,
              allDay: true,
            };
          });
          setEventData(newDataEvent);
        }
      }
    }
  }, [
    term,
    program,
    year,
    intake,
    confirmDialogAdd,
    allSubjects,
    selected,
    alignment,
    confirmDialogViewReference,
  ]);

  const handleFilterTerm = async (e, v) => {
    sessionStorage.setItem('term', e.target.value);
    sessionStorage.setItem('termValue', v.props.children[1]);
    setTerm(e.target.value);
    const versionData = await getCourseVersion(term);
    setAllSubjects(versionData);
    const versionDataConvert = Object.values(versionData);
    const subjectName = versionDataConvert[0]?.map((data) => {
      return { label: data.courseName, value: data.id };
    });
    const newSubjectName = [...subjectName, { label: '--', value: '' }];
    setSubjects(newSubjectName);
  };

  let childId = [];
  let childIds = [];

  useEffect(async () => {
    const versionData = await getCourseVersion(term);

    setAllSubjects(versionData);
    const versionDataConvert = Object.values(versionData);
    if (versionDataConvert) {
      const subjectName = versionDataConvert[0]?.map((data) => {
        return { label: data?.courseName, value: data?.id };
      });
      const newSubjectName = [...subjectName, { label: '--', value: '' }];
      setSubjects(newSubjectName);
    }

    const allSub = Object.values(versionData);
    const selectData = [...allSub];
    const checkedSubject = selectData[0]?.map((sData) => {
      if (sData.courseOffering.length > 0) {
        childIds = sData.courseOffering.map((cData) => {
          return cData.id;
        });
      }
      return sData.id;
    });
    setSelected([...checkedSubject, ...childIds]);
  }, []);

  useEffect(() => {
    if (term) {
      if (allSubjects.length > 0 && allSubjects.message != true) {
        const aaa = Object.values(allSubjects);
        if (aaa.length > 0) {
          const allSub = Object.values(allSubjects);
          const selectData = [...allSub];
          if (selectData) {
            const checkedSubject = selectData[0]?.map((sData) => {
              if (
                sData &&
                sData.courseOffering &&
                sData.courseOffering.length > 0
              ) {
                childId = sData.courseOffering.map((cData) => {
                  return cData.id;
                });
              }
              return sData.id;
            });
            setSelected([...checkedSubject, ...childId]);
          }
        }
      }
    }
  }, [allSubjects]);

  useEffect(() => {
    if (allSubjects) {
      const subjectsData = { ...allSubjects };
      const sData = Object.values(subjectsData);
      const newSubjects = sData[0]?.map((subjectData) => {
        return {
          id: subjectData.id,
          name: subjectData.courseName,
          children: subjectData.courseOffering.map((dataChild) => ({
            id: dataChild.id,
            name: dataChild.courseSectionId,
            children: [],
          })),
        };
      });
      setTreeItems(newSubjects);
    }
  }, [subjects]);

  const handleToggle = (event, nodeIds) => {
    if (event.target.nodeName !== 'svg') {
      return;
    }
    setExpanded(nodeIds);
  };

  useEffect(async () => {
    let terms = [];
    if (program && year && intake) {
      const termDatas = await getTermData({ program, year, intake });
      if (termDatas.length > 0) {
        terms = termDatas.map((ele) => {
          return { label: ele.Semester, value: ele.TermRecordId };
        });
        setTermOptions(terms);
      } else {
        setTerm('');
        setTermOptions([]);
        setSubjects([]);
        setSelectSubjectValue('');
      }
    }
  }, [program, year, intake]);

  let idCourse = [];
  const handleSelect = (event, nodeIds) => {
    const first = nodeIds[0];
    const allSub = Object.values(allSubjects);
    const selectData = [...allSub];
    const res = selectData[0].filter((eDa) => {
      return eDa.id == first;
    });
    if (res[0]?.courseOffering?.length > 0) {
      let courseData = res[0].courseOffering;
      idCourse = courseData.map((idData) => {
        return idData.id;
      });
    }
    if (selected.includes(first)) {
      setSelected((pre) => pre.filter((id) => id !== first));
      if (res[0]?.courseOffering?.length > 0) {
        setSelected((preState) =>
          preState.filter((item) => !idCourse.includes(item))
        );
      }
    } else {
      if (res[0]?.courseOffering?.length > 0) {
        setSelected((pre) => [...idCourse, ...pre]);
      }
      setSelected((p) => [first, ...p]);
    }
  };

  useEffect(() => {
    setTreeItems([]);
    setResources(resourcesData);
  }, [term]);

  const handleDateSelect = (clickInfo) => {
    let localTime = moment(clickInfo.start).format('YYYY-MM-DD'); // store localTime
    let localTimeEnd = moment(clickInfo.end).format('YYYY-MM-DD');
    let startTimed = moment(clickInfo.start).format('HH:mm');
    let startEnd = moment(clickInfo.end).format('HH:mm');
    setStartDate(localTime);
    setEndDate(localTimeEnd);
    setStartTime(startTimed);
    setEndTime(startEnd);
    setUpdateSession(false);
    setSessionValue('');
    setConfirmDialogAdd(true);
  };

  useEffect(async () => {
    let proposedDate = `${startDate}T${startTime}:00.000Z`;
    let proposedDateEnd = `${endDate}T${endTime}:00.000Z`;
    const faciltyAvailable = await getFaciltyAvailableData(
      proposedDate,
      proposedDateEnd
    );
    if (faciltyAvailable.Facility) {
      const facilityDataFull = Object.values(faciltyAvailable?.Facility);
      const facilityDatas = facilityDataFull?.map((e) => {
        return { label: e.facilityName, value: e.id };
      });
      const newFacilityDatas = [...facilityDatas, { label: '--', value: '' }];
      setfaciltyOptions(newFacilityDatas);
      setFacilityName(faciltyOptions[0]?.value);
    }

    if (faciltyAvailable.Faculty) {
      const facultyDataFull = Object.values(faciltyAvailable.Faculty);
      const facultyDatas = facultyDataFull.map((e) => {
        return { label: e.facultyName, value: e.ContactId };
      });
      const newFacultyDatas = [...facultyDatas, { label: '--', value: '' }];
      setFacultyOptions(newFacultyDatas);
      setFacultyName(facultyOptions[0]?.value);
    } else {
      setFacultyOptions([]);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    let locationData = history?.location?.state?.batchName;
    setLocationData(locationData);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let campusOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: item,
            id: keyVal.id,
            terms: JSON.parse(keyVal.terms),
          });
        });
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        setCourseOption(courseOptions);
        // setCampusOptions(campusOptions);
        if (locationData != undefined) {
          setProgramName(locationData);
          let e = { target: { name: 'program', value: locationData } };
          handleFilter(e, courseOptions);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    let programName = sessionStorage.getItem('programName');
    const cOpt = courseOption.filter((cOption) => cOption.label == programName);
  }, [courseOption]);
  useEffect(async () => {
    const faciltiyAndFacultyData = await getFacultyAndFacilty();
    const AllFacultyObject = Object.values(faciltiyAndFacultyData.Faculty);
    const facilitys = Object.values(faciltiyAndFacultyData);
    const activityData = [...facilitys[2]];
    const activitySession = activityData.map((e) => {
      return { label: e.label, value: e.value };
    });
    setSessions(activitySession);
    console.log('faciltiyAndFacultyData', AllFacultyObject);
    const AllfacultyData = AllFacultyObject.map((fData) => {
      return { label: fData.facultyName, value: fData.id };
    });
    console.log('AllfacultyData', AllfacultyData);
    setFacultyOptions(AllfacultyData);
  }, [
    confirmDialogAdd,
    confirmDialogDelete,
    alignment,
    confirmDialogAddReference,
  ]);

  const handleCancel = (e) => {
    setStartDate('');
    setEndDate('');
    setSessionValue('');
    setFacilityName('');
    setFacultyName('');
    // setSubjects('')
    setConfirmDialogAdd(false);
  };

  const handleAddEvent = async (e) => {
    let proposedDate = `${startDate}T${startTime}:00.000Z`;
    let proposedDateEnd = `${endDate}T${endTime}:00.000Z`;
    let dayData = DayArray.join(';');

    let obj = {
      Operation: 'Create',
      FacilityFacultyBooking: {
        termId: term,
        facultyId: facultyName,
        facilityId: facilityName,
        daySelected: dayData,
        courseVersionId: selectSubjectValue,
        courseOfferingId: selectSectionValue,
        academicPlannerActivityId: '',
        activityType: sessionValue,
        startDate: proposedDate,
        endDate: proposedDateEnd,
      },
    };
    await createBookedSlot(obj);
    toast.success('Save successfully');
    setConfirmDialogAdd(false);
  };
  const handleUpdateEventRefernce = async () => {
    const objRef = {
      Operation: 'Create',
      Activity: {
        termId: term,
        facultyIds: `${facultyName};${facultyNameTwo};${facultyNameThree}`,
        courseVersionId: selectSubjectValue,
        activityId: refActivityId.current,
        activityType: sessionValue,
        activityStartDate: `${startDate}T00:00:00.000Z`,
        activityEndDate: `${endDate}T00:00:00.000Z`,
        // activityEndDate: '2022-06-30T00:00:00.000Z',  // date formate use to send
      },
    };
    await updateReferenceActivities(objRef);
    toast.success('Update successfully');
    setConfirmDialogAddReference(false);
    setConfirmDialogReferenceView(false);
  };
  const handleUpdateEvent = async (e) => {
    let proposedDate = `${startDate}T${startTime}:00.000Z`;
    let proposedDateEnd = `${endDate}T${endTime}:00.000Z`;
    let obj = {
      FacilityFacultyBooking: {
        termId: term,
        facultyId: facultyName,
        facilityId: facilityName,
        courseVersionId: selectSubjectValue,
        courseOfferingId: selectSectionValue,
        academicPlannerActivityId: deleteDropEvent.current,
        activityType: sessionValue,
        startDate: proposedDate,
        endDate: proposedDateEnd,
      },
    };
    await addEventForBook(obj);
    toast.success('Update successfully');
    setConfirmDialogAdd(false);
  };

  const handleDeleteConfirm = async () => {
    let deleteObj = {
      Operation: 'Delete',
      FacilityFacultyBooking: {
        academicPlannerActivityId: deleteDropAcademic.current,
      },
    };
    const data = await getBookedSlotDelete(deleteObj);
    setConfirmDialogView(false);
    setConfirmDialogDelete(false);
  };

  function handleDeleteEvent() {
    setConfirmDialogDelete(true);
  }

  function handleMouseEnter(event) {
    setAnchorEl(event);
  }

  const handleMouseLeave = (e) => {
    setAnchorEl(null);
  };
  const handleEventClick = async (clickInfo) => {
    console.log('clickInfo.event._def.allDay', clickInfo.event._def.allDay);
    if (true) {
      refActivityId.current = clickInfo.event._def.extendedProps.activityId;
      setReadOnly(true);
      setConfirmDialogReferenceView(true);
      let localTimeStart = moment(clickInfo.event._instance.range.start).format(
        'YYYY-MM-DD'
      );
      setStartDate(localTimeStart);
      let localTimeEnd = moment(clickInfo.event._instance.range.end).format(
        'YYYY-MM-DD'
      );
      setEndDate(localTimeEnd);
      setSubjectView(clickInfo.event._def.extendedProps.subjectCourseName);
      setFacultyView(clickInfo.event._def.extendedProps.faculty1Name);
      setFacultyViewTwo(clickInfo.event._def.extendedProps.faculty2Name);
      setFacultyViewThree(clickInfo.event._def.extendedProps.faculty3Name);
      const subValue = subjects.filter(
        (e) => e.value == clickInfo.event._def.extendedProps.subjectId
      );

      setSelectSubjectValue(subValue[0].value);
      const facility1 = facultyOptions.filter(
        (e) => e.value == clickInfo.event._def.extendedProps.faculty1Id
      );
      setFacultyName(facility1[0]?.value);
      const facility2 = facultyOptions.filter(
        (e) => e.value == clickInfo.event._def.extendedProps.faculty2Id
      );
      setFacultyNameTwo(facility2[0]?.value);
      const facility3 = facultyOptions.filter(
        (e) => e.value == clickInfo.event._def.extendedProps.faculty3Id
      );
      setFacultyNameThree(facility3[0]?.value);
      setSessionValue(clickInfo.event._def.title);
    } else {
      // setConfirmDialogView(true);
      setReadOnly(false);
      let localTimeStart = moment(clickInfo.event._instance.range.start).format(
        'YYYY-MM-DDTHH:mm'
      );
      setStartDate(localTimeStart);
      let localTimeEnd = moment(clickInfo.event._instance.range.end).format(
        'YYYY-MM-DDTHH:mm'
      );
      setEndDate(localTimeEnd);
      deleteDropEvent.current = clickInfo.event.id;
      deleteDropAcademic.current =
        clickInfo.event._def.extendedProps.academicPlannerId;

      const subValue = subjects.filter((e) => e.value == selectSubjectValue);
      setSelectSubjectValue(subValue);
      const faciltyfacultySubjectData = await getAllFacultyFacilitySubject(
        clickInfo.event._def.extendedProps.academicPlannerId
      );
      const allData = Object.values(faciltyfacultySubjectData);
      if (allData && allData[0].name != 'Error') {
        const subjectSectionName = allData[0] && Object.values(allData[0]);
        setSubjectView(subjectSectionName[0]?.courseName);
        setFacultyView(subjectSectionName[0]?.facultyName);
        setFaciltyView(subjectSectionName[0]?.facilityName);
        setSectionView(subjectSectionName[0]?.courseOfferingSectionId);
        setSessionValue(clickInfo.event.title);
      }
    }
  };

  const handleEdit = () => {
    setConfirmDialogAdd(true);
    setConfirmDialogView(false);
    setUpdateSession(true);
  };

  const handleEditRef = () => {
    setConfirmDialogAddReference(true);
  };

  const handleEvents = (events) => {
    setState({
      currentEvents: events,
    });
  };

  const handleChangedStartDate = (e) => {
    setStartDate(e.target.value);
  };

  const handleChangedStartTime = (e) => {
    setStartTime(e.target.value);
  };

  const handleChangedEndTime = (e) => {
    setEndTime(e.target.value);
  };

  const handleChangedEndDate = (e) => {
    setEndDate(e.target.value);
  };
  const handleSelectSubjectChange = (e) => {
    setSelectSubjectValue(e.target.value);
    const subjectData = Object.values(allSubjects);
    const sectionData = subjectData[0]?.filter(
      (ele) => ele.id == e.target.value
    );
    const sectionDropdown =
      subjectData &&
      subjectData.length > 0 &&
      sectionData[0]?.courseOffering?.map((dataEle) => {
        return { label: dataEle.courseSectionId, value: dataEle.id };
      });
    setSections(sectionDropdown);
  };

  const handleSelectSectionChange = (e) => {
    setSelectSectionValue(e.target.value);
  };
  function renderEventContent(eventInfo) {
    console.log('renderEventContent:      ==');
    const toopTiptext = (
      <table className={classesItem.tooltipTable}>
        <tr className={classesItem.tooltipTable_Tr}>
          <th className={classesItem.tooltipTable_th}>Activity Information</th>
          <th className={classesItem.tooltipTable_th}></th>
        </tr>
        <tr>
          <th className={classesItem.tooltipTable_th}>Subject</th>
          <td className={classesItem.tooltipTable_td}>
            {eventInfo.event.title}
          </td>
        </tr>{' '}
        <tr>
          <th className={classesItem.tooltipTable_th}>Faculty</th>
          <td className={classesItem.tooltipTable_td}>
            {eventInfo.event.extendedProps.facilityName}
          </td>
        </tr>{' '}
        <tr>
          <th className={classesItem.tooltipTable_th}>Facility</th>
          <td className={classesItem.tooltipTable_td}>{faciltyView}</td>
        </tr>
      </table>
    );
    return (
      <div>
        <>
          <BlueOnGreenTooltip title={toopTiptext} placement="bottom">
            <div>
              <i className="text-change"> {eventInfo.event.title}</i>
            </div>
          </BlueOnGreenTooltip>
        </>
      </div>
    );
  }
  // ref for the reference the callback function
  const revertDropEvent = useRef();
  const deleteDropEvent = useRef();
  const refActivityId = useRef();
  const deleteDropAcademic = useRef();
  // event drop callBack function
  function handleDrop(event) {
    revertDropEvent.current = event.revert;
    setConfirmDialog(true);
    //  event.revert()
  }

  function handleDragStop(event, jsEvent, ui, view) {
    console.log('calendar - stop', event);
  }

  function handleResize(info) {
    console.log('info- resize', info);
  }
  const handleAdd = () => {
    setConfirmDialogAdd(true);
    setUpdateSession(false);
  };

  const handleSelectFacultyChange = (e, value) => {
    setFacultyName(e.target.value);
  };

  const handleSelectFacultyTwoChange = (e, value) => {
    setFacultyNameTwo(e.target.value);
  };

  const handleSelectFacultyThreeChange = (e, value) => {
    setFacultyNameThree(e.target.value);
  };
  const handleCheckSelectAll = (e, value) => {
    if (value) {
      let arrDataOff = [];
      let arrDataOffRes = [];
      const allSubjectChecked = Object.values(allSubjects);
      const selectData = [...allSubjectChecked];
      const checkedSubject = selectData[0].map((sData) => {
        if (sData.courseOffering.length > 0) {
          arrDataOff = sData.courseOffering.map((cData) => {
            return cData.id;
          });
        }
        return sData.id;
      });
      setChecked(true);
      const arrAll = [...checkedSubject, ...arrDataOff];
      setSelected(arrAll);
    } else {
      const allSubjectChecked = Object.values(allSubjects);
      const selectData = [...allSubjectChecked];
      const checkedSubject = selectData[0]?.map((sData) => {
        return sData.value;
      });

      setChecked(false);
      setSelected(checkedSubject);
    }
  };

  const handleCheckSelectAllUnAssigned = async (e, value) => {
    const termSession = await getAcademicPlannerSession(term);
    const propertyNames = termSession[term];
    if (alignment === 'session') {
      if (value) {
        const nonAssignedSubject = propertyNames.filter((aData) => {
          return !aData.SubjectPlanner;
        });
        setCheckedAssigned(true);
        if (propertyNames) {
          const newEvents = [...nonAssignedSubject];
          const transformed = newEvents.map(
            ({
              activity,
              endDate,
              academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              facilityName,
              facilityType,
              id,
              startDate,
              startTime,
              endTime,
            }) => ({
              title: activity,
              end: `${endDate}T${endTime.slice(0, 8)}`,
              academicPlannerId: academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              facilityName,
              facilityType,
              id,
              start: `${startDate}T${startTime.slice(0, 8)}`,
            })
          );
          const newDataEventUnAssiged = transformed.map((ele) => {
            return {
              ...ele,
              backgroundColor: getColor(ele.title),
              editable: true,
              allDay: false,
            };
          });
          setEventData((pre) => [...pre, ...newDataEventUnAssiged]);
        }
      } else {
        setCheckedAssigned(false);
        let result = propertyNames.filter(function (o1) {
          return selected.some(function (o2) {
            if (o1.SubjectPlanner) {
              return o1?.SubjectPlanner?.courseVersionId === o2; // return the ones with equal id
            }
          });
        });
        if (propertyNames) {
          const newEvents = [...result];
          const transformed = newEvents.map(
            ({
              activity,
              endDate,
              academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              facilityName,
              facilityType,
              id,
              startDate,
              startTime,
              endTime,
            }) => ({
              title: activity,
              end: `${endDate}T${endTime.slice(0, 8)}`,
              academicPlannerId: academicPlannerActivityId,
              facilityBookingNumber,
              facilityCampus,
              facilityCapacity,
              facilityName,
              facilityType,
              id,
              start: `${startDate}T${startTime.slice(0, 8)}`,
            })
          );
          const newDataEvent = transformed.map((ele) => {
            return {
              ...ele,
              backgroundColor: getColor(ele.title),
              editable: true,
              allDay: false,
            };
          });
          setEventData(newDataEvent);
        }
      }
    }
  };

  const handleSelectFacilityChange = (e, value) => {
    setFacilityName(e.target.value);
  };

  const handleProgram = (e, value) => {
    setProgram(e.target.value);
  };

  const handleYear = (e, value) => {
    setYear(e.target.value);
    sessionStorage.setItem('year', e.target.value);
  };
  const handleIntake = (e, value) => {
    setIntake(e.target.value);
    sessionStorage.setItem('intake', e.target.value);
    setTermOptions([]);
  };

  const handleSelectProgramChange = (e, value) => {
    setSessionValue(e.target.value);
  };

  const handleChangeRecurrent = () => {
    setRecurrent(!recurrent);
  };

  const handleChecked = (e) => {
    const checkedDay = DayArray.includes(e.target.id);
    if (checkedDay) {
      const index = DayArray.indexOf(e.target.id);
      if (index > -1) {
        DayArray.splice(index, 1); // 2nd parameter means remove one item only
      }
    } else {
      DayArray.push(e.target.id);
    }
  };

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  const handleChanges = (event, newAlignment) => {
    setAlignments(newAlignment);
  };

  console.log('newAlignment', alignment);
  return (
    <Box>
      <ToastContainer />
      <Box mt={2} mb={2} className={classes.sortingSection}>
        <KenSelect
          name="program"
          label="Academic Program *"
          options={courseOption}
          value={program}
          dropdownColor="#ffffff"
          onChange={(el) => handleProgram(el)}
          required={true}
        />
        <KenSelect
          label="Year *"
          name="year"
          options={yearOptions}
          value={year}
          dropdownColor="#ffffff"
          onChange={(el) => handleYear(el)}
          required={true}
        />
        <KenSelectWrap
          name="intake"
          label="Intake *"
          options={intakeOptions}
          value={intake}
          dropdownColor="#FFFFFF"
          onChange={(el) => handleIntake(el)}
          required
        />
        <KenSelectWrap
          name="term"
          label="Term"
          options={termOptions}
          value={term}
          dropdownColor="#FFFFFF"
          onChange={(el, v) => handleFilterTerm(el, v)}
          required
        />
        {program && year && intake && term && (
          <Button
            className="btn-toggle"
            variant="contained"
            onClick={() => setToggle(!toggle)}
          >
            Subjects
          </Button>
        )}
        <ToggleButtonGroup
          color="primary"
          value={alignment}
          exclusive
          onChange={handleChange}
          className="main-tgl-btn-div"
        >
          <ToggleButton value="reference" className="tgl-btn">
            Reference
          </ToggleButton>
          <ToggleButton value="session" className="tgl-btn">
            Session
          </ToggleButton>
        </ToggleButtonGroup>

        <ToggleButtonGroup
          color="primary"
          value={alignments}
          exclusive
          onChange={handleChanges}
          className="main-tgl-btn-div"
        >
          <ToggleButton value="faculty" className="tgl-btn">
            FACULTY
          </ToggleButton>
          <ToggleButton value="facilty" className="tgl-btn">
            FACILITY
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Box container className="calendar-main-box">
        {program && year && intake && term && (
          <>
            <Box
              className="subject-section"
              style={
                toggle
                  ? {
                    marginTop: '69px',
                    display: 'block ',
                    right: '32px',
                    transition: '0.5s',
                  }
                  : { display: '', right: '-100%', transition: '0.5s' }
              }
            >
              <FormControlLabel
                label={'UnAssigned'}
                control={
                  <Checkbox
                    checked={checkedAssinged}
                    value={checkedAssinged}
                    indeterminate={checkedAssinged}
                    onChange={handleCheckSelectAllUnAssigned}
                  />
                }
              />
              <Typography className="subject-title">SUBJECTS</Typography>
              <FormControlLabel
                label={!checked ? 'Select All' : 'Unselect All'}
                control={
                  <Checkbox
                    checked={checked}
                    value={checked}
                    indeterminate={checked}
                    onChange={handleCheckSelectAll}
                  />
                }
              />
              <ControlledTreeView
                treeItems={treeItems}
                expanded={expanded}
                allSubjects={allSubjects}
                selected={selected}
                onNodeToggle={handleToggle}
                onNodeSelect={handleSelect}
              />
            </Box>
            <Box className="calendar-part">
              <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                headerToolbar={{
                  left: 'prev,next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay',
                }}
                allDaySlot={true}
                selectLongPressDelay={1}
                longPressDelay={1}
                eventLongPressDelay={1}
                // hoverLongPressDelay={1}
                initialView="dayGridMonth"
                editable={true} // False for stop resize
                selectable={true} // false for stop click the event
                // selectMirror={true}
                dayMaxEvents={true}
                weekends={state.weekendsVisible}
                events={eventData} // alternatively, use the `events` setting to fetch from a feed
                select={handleDateSelect}
                eventContent={renderEventContent} // custom render function to change name of event in calendar
                eventClick={handleEventClick}
                eventMouseEnter={(e) => handleMouseEnter(e)}
                eventMouseLeave={(e) => handleMouseLeave(e)}
                eventDrop={handleDrop}
                eventDragStop={handleDragStop}
                eventResizeStop={handleResize}
                eventTimeFormat={{
                  hour: 'numeric',
                  minute: '2-digit',
                  meridiem: false,
                }}
                eventResize={function (info) {
                  alert(
                    info.event.title +
                    ' end is now ' +
                    info.event.end.toISOString()
                  );

                  if (!window.confirm('is this okay?')) {
                    info.revert();
                  }
                }}
                eventsSet={handleEvents} // called after events are initialized/added/changed/removed
              /* you can update a remote database when these fire:
        eventAdd={function(){}}
        eventChange={function(){}}
        eventRemove={function(){}}  
        */
              />
            </Box>
          </>
        )}
      </Box>
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Confirmation
          </Typography>
        }
        open={confirmDialog}
        // icon={<RiCheckFill />}
        handleClose={() => setConfirmDialog(false)}
        negativeButtonClick={() => {
          // setConfirm(false);
          if (revertDropEvent.current) revertDropEvent.current();
          setConfirmDialog(false);
        }}
        positiveButtonClick={() => setConfirmDialog(false)}
        positiveButtonText={'Submit'}
        negativeButtonText="Cancel"
        dividers
      >
        <p>{`Are you want to change event time to ? `}</p>
      </KenDialog>
      {/* View Session Dialoue */}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            <b>View Activity</b>{' '}
            <Button
              // color="primary"
              variant="outlined"
              size="small"
              onClick={() => handleDeleteEvent()}
              style={{ float: 'right', marginLeft: '8px' }}
            >
              Delete Activity
            </Button>
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={() => handleEdit()}
              style={{ float: 'right' }}
            >
              Edit Activity
            </Button>
          </Typography>
        }
        // style={{ width: '40%', height: '100%' }}
        open={confirmDialogView}
        // icon={<RiCheckFill />}
        handleClose={() => setConfirmDialogView(false)}
        negativeButtonClick={() => {
          setConfirmDialogView(false);
        }}
        // positiveButtonClick={() => setConfirmDialogView(false)}
        // hideNegativeButton={true}
        hidePositiveButton={true}
        positiveButtonText={'Edit'}
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <b>Session:</b>{' '}
          </Grid>
          <Grid item xs={12} md={9}>
            {sessionValue}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Start Date:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {startDate}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>End Date:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {endDate}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Subject:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {subjectView ? subjectView : 'N/A'}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Section:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {sectionView ? sectionView : 'N/A'}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Faculty:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {facultyView ? facultyView : 'N/A'}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Facility:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {faciltyView ? faciltyView : 'N/A'}
          </Grid>
        </Grid>
      </KenDialog>

      {/* View Pop reference */}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            <b>View Reference</b>{' '}
            <Button
              // color="primary"
              variant="outlined"
              size="small"
              // onClick={() => handleDeleteEvent()}
              style={{ float: 'right', marginLeft: '8px' }}
            >
              Delete
            </Button>
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={() => handleEditRef()}
              style={{ float: 'right' }}
            >
              Edit
            </Button>
          </Typography>
        }
        // style={{ width: '40%', height: '100%' }}
        open={confirmDialogViewReference}
        // icon={<RiCheckFill />}
        handleClose={() => setConfirmDialogReferenceView(false)}
        negativeButtonClick={() => {
          setConfirmDialogReferenceView(false);
        }}
        // positiveButtonClick={() => setConfirmDialogView(false)}
        // hideNegativeButton={true}
        hidePositiveButton={true}
        positiveButtonText={'Edit'}
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <b>Type of Activity:</b>{' '}
          </Grid>
          <Grid item xs={12} md={9}>
            {sessionValue}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Start Date:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {startDate}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>End Date:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {endDate}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Subject:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {subjectView ? subjectView : 'N/A'}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Faculty1:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {facultyView ? facultyView : 'N/A'}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Faculty2:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {facultyViewTwo ? facultyViewTwo : 'N/A'}
          </Grid>
          <Grid item xs={12} md={3}>
            <b>Faculty3:</b>{' '}
          </Grid>
          <Grid item xs={12} md={3}>
            {facultyViewThree ? facultyViewThree : 'N/A'}
          </Grid>
        </Grid>
      </KenDialog>
      {/* Add Session Dialoue */}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            {!updateSession ? <b>Add Activity</b> : <b>Edit Activity</b>}
          </Typography>
        }
        open={confirmDialogAdd}
        // icon={<RiCheckFill />}
        handleClose={() => setConfirmDialogAdd(false)}
        negativeButtonClick={
          // setConfirm(false);
          // if (revertDropEvent.current) revertDropEvent.current();
          (e) => handleCancel(e)
          // (e) => setConfirmDialogAdd(false)
        }
        positiveButtonClick={
          !updateSession
            ? (e) => handleAddEvent(e)
            : (e) => handleUpdateEvent(e)
        }
        positiveButtonText={!updateSession ? 'Submit' : 'Update'}
        negativeButtonText={'Cancel'}
        dividers
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <KenSelectWrap
              disabled={readOnly}
              label="Type of sessions"
              options={sessions}
              value={sessionValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectProgramChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'startDate'}
              label="Start Date"
              // disabled={false}
              value={startDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedStartDate(e)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'startTime'}
              label="Start Time"
              value={startTime}
              type="time"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedStartTime(e)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'endDate'}
              label="End Date"
              // disabled={false}
              value={endDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedEndDate(e)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'endTime'}
              label="End Time"
              value={endTime}
              type="time"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedEndTime(e)}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Checkbox
              checked={recurrent}
              onChange={handleChangeRecurrent}
              color="secondary"
            />
            Recurrent Session
          </Grid>
          {recurrent && (
            <Grid container spacing={0}>
              <Grid item xs={12} md={12}>
                <div style={{ display: 'flex', paddingLeft: '16px' }}>
                  {recurrenceDay.map((eData) => {
                    return (
                      <div class="round">
                        <input
                          type="checkbox"
                          onClick={(e) => handleChecked(e, eData.id)}
                          id={eData.id}
                        />
                        <label for={eData.id} className="f-color-day">
                          {eData.label}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Subject"
              options={subjects}
              // disabled={false}
              value={selectSubjectValue}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleSelectSubjectChange(e)}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Section"
              options={sections}
              value={selectSectionValue}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleSelectSectionChange(e)}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty"
              options={facultyOptions}
              value={facultyName}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Facility"
              options={faciltyOptions}
              value={facilityName}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacilityChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
        </Grid>
      </KenDialog>

      {/* add reference edit popup */}
      {/* <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            {<b>Edit Reference</b>}
          </Typography>
        }
        open={confirmDialogAddReference}
        // icon={<RiCheckFill />}
        handleClose={() => setConfirmDialogAddReference(false)}
        negativeButtonClick={
          // setConfirm(false);
          // if (revertDropEvent.current) revertDropEvent.current();
          (e) => setConfirmDialogAddReference(false)
          // (e) => setConfirmDialogAdd(false)
        }
        positiveButtonClick={(e) => handleUpdateEventRefernce(e)}
        positiveButtonText={'Update'}
        negativeButtonText={'Cancel'}
        dividers
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <KenSelectWrap
              // disabled={readOnly}
              label="Type of Activity"
              options={sessions}
              value={sessionValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectProgramChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'startDate'}
              label="Start Date"
              // disabled={readOnly}
              value={startDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedStartDate(e)}
            />
          </Grid>
          
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'endDate'}
              label="End Date"
              // disabled={readOnly}
              value={endDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedEndDate(e)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Subject"
              options={subjects}
              // disabled={readOnly}
              value={selectSubjectValue}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleSelectSubjectChange(e)}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty1"
              options={facultyOptions}
              value={facultyName}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty2"
              options={facultyOptions}
              value={facultyNameTwo}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyTwoChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty3"
              options={facultyOptions}
              value={facultyNameThree}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyThreeChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
        </Grid>
      </KenDialog> */}
      <Reference
        title={'Edit Reference'}
        // children={}
        isOpen={confirmDialogAddReference}
        handleClose={() => setConfirmDialogAddReference(false)}
        // handleEvent={handleUpdateEventRefernce}
        positiveBtn={'Edit'}
        negativeBtn={'Cancel'}
        handleSelectSubjectChange={handleSelectSubjectChange}
        sessions={sessions}
        subjects={subjects}
        facultyOptions={faciltyOptions}
        selectSubjectValue={selectSubjectValue}
        id={'sdsdsd'}
      />

      {/* Delete Popup */}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            <b></b>
          </Typography>
        }
        // maxWidth={10}
        open={confirmDialogDelete}
        // icon={<RiCheckFill />}
        handleClose={() => setConfirmDialogDelete(false)}
        negativeButtonClick={() => {
          setConfirmDialogDelete(false);
        }}
        positiveButtonClick={() => handleDeleteConfirm()}
        // hideNegativeButton={true}
        // hidePositiveButton={true}
        positiveButtonText={'Delete'}
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={2}>
          {/* <Grid item xs={12} md={6}>
            <b>Session</b>{' '}
          </Grid> */}
          <Grid item xs={12} md={12}>
            Are you sure you want to delete ?
          </Grid>
        </Grid>
      </KenDialog>
    </Box>
  );
}
